import { Common, color } from '@stockbit/ui';

const { Button, Flex, Text } = Common;

interface EmptyWatchlistProps {
  onAdd: () => void;
}

const EmptyWatchlist = ({ onAdd }: EmptyWatchlistProps) => (
  <Flex
    direction="column"
    align="center"
    justify="center"
    px="30px"
    style={{ height: 'calc(100% - 40px)' }}
  >
    <Text>Your watchlist is empty</Text>
    <Button block round type="primary" margin="10px 0" onClick={onAdd}>
      <Text color={color.light} align="center">
        + Add Stocks Now
      </Text>
    </Button>
  </Flex>
);

export default EmptyWatchlist;
